
import {
    SET,
    REINIT
} from './types';

import {
    Actions,
} from './actions';

import {
    DepartmentModal
} from './departmentmodal';

export const departmentathenastate = (
    context: any,
    initial?:DepartmentModal[],
) => {
    const initValue = initial || [];

    return (
        state: DepartmentModal[] = initValue,
        action:Actions,
    ) => {
        const {
            type,
            payload,
        } = action;
        let updated = state;
        switch (type) {
            case SET:
                updated = payload
                break;

            case REINIT:
                updated = initValue;
                break;
        }
        return updated;
    }
};

